<template>
    <div>
        <!-- 头部 -->
        <v-header></v-header>
        <!-- 轮播图 -->
        <v-banner></v-banner>
        <!-- 产品列表 -->
        <!-- <div class="wrapCenter product-list">
            <div class="row">
                <div class="col-sm-6" :class="{'pull-left': platform == 1}">
                    <img src="../assets/img/index-a8.png" width="100%" />
                </div>
                <div class="col-sm-6 product-info" :class="{'pull-right': platform == 1}">
                    <h3 v-if="platform == 1">TANGMAI A8</h3>
                    <h3 v-if="platform == 1">双动圈系列耳机</h3>
                    <div class="product-desc" v-if="platform == 1">
                        <p>仿生声囊 音效更强</p>
                        <p>四核能量 HiFi音质</p>
                    </div>
                    <h3 v-if="platform == 2">TANGMAI A8 双动圈系列耳机</h3>
                    <div class="product-desc" v-if="platform == 2">
                        <p>仿生声囊 音效更强 四核能量 HiFi音质</p>
                    </div>
                    <div class="btn-group" @click="$router.push({path:'/product/a8'})">
                        <button type="button" class="btn btn-default"><i class="icon-eye"></i></button>
                        <button type="button" class="btn btn-default btn-text">了解详情</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapCenter product-list" id="product-c5">
            <div class="row">
                <div class="col-sm-6" :class="{'pull-right': platform == 1}">
                    <img src="../assets/img/index-c5.png" width="100%" />
                </div>
                <div class="col-sm-6 product-info" :class="{'pull-left': platform == 1}">
                    <h3 v-if="platform == 1">TANGMAI C5</h3>
                    <h3 v-if="platform == 1">入耳式系列耳机</h3>
                    <div class="product-desc" v-if="platform == 1">
                        <p>青春锋芒 锐不可挡</p>
                        <p>独特三角造型 三频立体解析</p>
                        <p>交响式演绎</p>
                    </div>
                    <h3 v-if="platform == 2">TANGMAI C5 入耳式系列耳机</h3>
                    <div class="product-desc" v-if="platform == 2">
                        <p>青春锋芒 锐不可挡 独特三角造型 三频立体解析 交响式演绎</p>
                    </div>
                    <div class="btn-group" @click="$router.push({path:'/product/c5'})">
                        <button type="button" class="btn btn-default"><i class="icon-eye"></i></button>
                        <button type="button" class="btn btn-default btn-text">了解详情</button>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn btn-default product-more" @click="$router.push({path:'/earphoneList'})">了解更多</button> -->

        <!-- 产品支持 -->
        <!-- <div class="index-box">
            <div class="wrapCenter">
                <h2>产品支持</h2>
                <p class="index-box-desc">对唐麦产品有疑问？我们随时为你提供帮助</p>
                <ul class="row index-box-list support">
                    <li class="col-xs-6 col-sm-3" v-for="item in productSupport">
                        <router-link class="index-box-icon support-icon" :to="{path: item.url}" tag="div">
                            <i :class="item.iconPath"></i>
                        </router-link>
                        <p class="index-box-name"> {{ item.name }} </p>
                    </li>
                </ul>
            </div>
        </div> -->
        
        <!-- 关注我们 -->
        <!-- <div class="index-box concern-box">
            <div class="wrapCenter">
                <h2>关注我们</h2>
                <p class="index-box-desc">时刻关注唐麦的所有最新动态</p>
                <ul class="index-box-list concern-us">
                    <li>
                        <a href="http://weibo.com/tangmaikeji" target="_blank">
                        <div class="index-box-icon concern-icon icon-weibo">
                            <i></i>
                        </div>
                        </a>
                        <p class="index-box-name"> 唐麦微博 </p>
                    </li>
                    <li>
                        <div class="index-box-icon concern-icon icon-wichat" data-toggle="modal" data-target="#modalWechat">
                            <i></i>
                        </div>
                        <p class="index-box-name"> 微信公众号 </p>
                    </li>
                    <li>
                        <a href="https://tangmaizhengpin.taobao.com/" target="_blank">
                        <div class="index-box-icon concern-icon icon-taobao">
                            <i></i>
                        </div>
                        </a>
                        <p class="index-box-name"> 淘宝专卖店 </p>
                    </li>
                    <li>
                        <a href="https://tangmai.tmall.com/" target="_blank">
                        <div class="index-box-icon concern-icon icon-tmall">
                            <i></i>
                        </div>
                        </a>
                        <p class="index-box-name"> 天猫旗舰店 </p>
                    </li>
                    <li>
                        <a href="http://mall.jd.com/index-149026.html" target="_blank">
                        <div class="index-box-icon concern-icon icon-jd">
                            <i></i>
                        </div>
                        </a>
                        <p class="index-box-name"> 京东旗舰店 </p>
                    </li>
                    <li>
                        <div class="index-box-icon concern-icon icon-team" @click="$router.push({path: '/about/join'})">
                            <i></i>
                        </div>
                        <p class="index-box-name"> 加入唐麦 </p>
                    </li>
                </ul>
            </div>
        </div> -->

        <!-- 页面底部 -->
        <v-footer></v-footer>
        <!-- 回到顶部 -->
        <goto-top></goto-top>
    </div>
</template>
<script>
// 头部
import VHeader from "../components/header"
// banner
import VBanner from "../components/banner"
// 尾部
import VFooter from "../components/footer"
// 回到顶部
import GotoTop from "../components/gotoTop"

    export default{
        components:{
            VHeader,
            VBanner,
            VFooter,
            GotoTop
        },
        data(){
            return {
                platform: 1,   //1 pc端   2 mobile端
                productList:[
                    {
                        imgPath: require("../assets/img/index-a8.png"),
                        title_en: "TANGMAI A8",
                        title_cn: "双动圈系列耳机",
                        desc: ["仿生声囊 音效更强", "四核能量 HiFi音质"],
                        url: "/product/a8"
                    },
                    {
                        imgPath: require("../assets/img/index-c5.png"),
                        title_en: "TANGMAI C5",
                        title_cn: "入耳式系列耳机",
                        desc: ["青春锋芒 锐不可挡", "独特三角造型 三频立体解析", "交响式演绎"],
                        url: "/product/c5"
                    }
                ],
                productSupport:[
                    {
                        name: "防伪查询",
                        iconPath: 'icon-check',
                        url: "/server/security"
                    },
                    {
                        name: "使用说明",
                        iconPath: 'icon-instructions',
                        url: "/server/instructions"
                    },
                    {
                        name: "煲机教程",
                        iconPath: 'icon-course',
                        url: "/server/tutorial"
                    },
                    {
                        name: "无损音乐",
                        iconPath: 'icon-music',
                        url: "/server/lossless"
                    }
                ],
            }
        },
        mounted(){
            if($(window).width() > 786){
                this.platform = 1;
            }else{
                this.platform = 2;
            }
        }
    }
</script>
<style scoped>
    .product-list{
        margin-top: 60px;
        background: #e7e7e7;
    }

    .product-list>.row{
        position: relative;
    }

    .product-list .product-info{
        padding: 80px 80px;
        height: 100%;
        position: static;
        /*overflow:hidden; padding-bottom:9999px; margin-bottom:-9999px;*/
        
    }

    #product-c5 .pull-right{
        background: url(../assets/img/index-c5-bg.jpg) no-repeat center;
        background-size: cover;
        background-clip: content-box;
    }

    .product-list .icon-eye{
        width: 26px;
        height: 17px;
        background: url(../assets/img/icons/eye.png) no-repeat;
        background-position: center center;
        display: inline-block;
    }

    .product-list .btn{
        border: none;
        border-left: 1px solid #ffffff;
        background: #ad0000;
        color: #ffffff;
        height: 30px;
        border-radius: 15px;
        font-size: 12px;
        padding: 6px 12px;
    }

    .product-list .btn:hover{
        border-left: 1px solid #ffffff;
    }

    .product-list h3{
        font-size: 32px;
        margin-bottom: 14px;
    }

    .product-list .product-desc{
        padding-top: 14px;
        border-top: 1px solid #313131;
    }

    .product-list .product-desc p{
        font-size: 20px;
        color: #727272;
        line-height: 28px;
    }

    .product-list .btn-group{
        position: absolute;
        bottom: 40px;
    }

    .product-list .btn.btn-text{
        padding: 6px 20px;
    }

    .product-more{
        width: 240px;
        height: 60px;
        margin: 80px auto;
        display: block;
        border-radius: 36px;
        color: #848484;
        border-color: #848484;
    }

    .product-more:hover{
        color: #ad0000;
        border-color: #ad0000;
        box-shadow: 2px 2px 2px 0px #ad0000;
    }

    .product-more:hover, .product-more:focus{
        background: transparent;
    }

    .index-box{
        text-align: center;
        border-top: 1px #e7e7e7 solid;
        padding: 120px 0px;
        width: 100%;
        overflow: hidden;
    }

    .index-box h2{
        font-size: 32px;
        color: #848484;
    }

    .index-box-desc{
        color: #727272;
        margin-top: 10px;
    }

    .index-box-list{
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
        margin-top: 60px;
        /*width: 60%;*/
        float: left;
    }

    .index-box-list.support{
        width: 60%;
    }

    /*.index-box-list.concern-us{
        width: 68%;
    }*/
    .index-box-list li{
        float: left;
    }

    .index-box-list.concern-us li{
        margin-right: 30px;
    }

    .index-box-list.concern-us li:last-child{
        margin-right: 0px;
    }

    .index-box-list li .index-box-icon{
        border: 1px #848484 solid;
        border-radius: 50%;
        padding: 20px;
        margin: 0 auto;
        width: 72px;
        cursor: pointer;
    }

    

    .index-box-list li .concern-icon{
        padding: 14px;
        width: 54px;
        height: 54px;
    }

    .index-box-list li .index-box-icon i{
        width: 30px;
        height: 30px;
        display: block;
        margin: 0px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
    }

    .index-box-list li .concern-icon i{
        width: 26px;
        height: 26px;
    }

    .index-box-list li .index-box-icon i.icon-check{
        background-image: url(../assets/img/icons/check.png);
    }

    .index-box-list li .index-box-icon i.icon-course{
        background-image: url(../assets/img/icons/course.png);
    }

    .index-box-list li .index-box-icon i.icon-instructions{
        background-image: url(../assets/img/icons/instructions.png);
    }
    .index-box-list li .index-box-icon i.icon-music{
        background-image: url(../assets/img/icons/music.png);
    }

    .index-box-list li .index-box-icon.icon-weibo i{
        background-image: url(../assets/img/icons/weibo.png);
    }

    .index-box-list li .index-box-icon:hover i.icon-check{
        background-image: url(../assets/img/icons/check_w.png);
    }

    .index-box-list li .index-box-icon:hover i.icon-course{
        background-image: url(../assets/img/icons/course_w.png);
    }

    .index-box-list li .index-box-icon:hover i.icon-instructions{
        background-image: url(../assets/img/icons/instructions_w.png);
    }
    .index-box-list li .index-box-icon:hover i.icon-music{
        background-image: url(../assets/img/icons/music_w.png);
    }

    .index-box-list li .index-box-icon.icon-weibo i{
        background-image: url(../assets/img/icons/weibo.png);
    }

    

    .index-box-list li .index-box-icon.icon-wichat i{
        background-image: url(../assets/img/icons/wichat.png);
    }

    
    .index-box-list li .index-box-icon.icon-taobao i{
        background-image: url(../assets/img/icons/taobao.png);
    }

    

    .index-box-list li .index-box-icon.icon-tmall i{
        background-image: url(../assets/img/icons/tmall.png);
    }

    

    .index-box-list li .index-box-icon.icon-jd i{
        background-image: url(../assets/img/icons/jd.png);
    }

    

    .index-box-list li .index-box-icon.icon-team i{
        background-image: url(../assets/img/icons/team.png);
    }

    


    .index-box-name{
        text-align: center;
        color: #a6a6a6;
        margin-top: 10px;
    }

     @media (min-width: 769px){
         .index-box-list li .index-box-icon:hover{
            background: #ad0000;
            border-color: #ad0000;
        }

         .index-box-list li .index-box-icon.icon-weibo:hover i{
            background-image: url(../assets/img/icons/weibo_w.png);
        }

        .index-box-list li .index-box-icon.icon-weibo:hover{
            background-color: #d92a1b;
            border-color: #d92a1b;
        }

         .index-box-list li .index-box-icon.icon-wichat:hover i{
            background-image: url(../assets/img/icons/wichat_w.png);
        }

        .index-box-list li .index-box-icon.icon-wichat:hover{
            background-color: #6fb74e;
            border-color: #6fb74e;
        }

         .index-box-list li .index-box-icon.icon-taobao:hover i{
            background-image: url(../assets/img/icons/taobao_w.png);
        }

        .index-box-list li .index-box-icon.icon-taobao:hover{
            background-color: #db470c;
            border-color: #db470c;
        }
         .index-box-list li .index-box-icon.icon-tmall:hover i{
            background-image: url(../assets/img/icons/tmall_w.png);
        }

        .index-box-list li .index-box-icon.icon-tmall:hover{
            background-color: #ba220c;
            border-color: #ba220c;
        }

         .index-box-list li .index-box-icon.icon-team:hover i{
            background-image: url(../assets/img/icons/team_w.png);
        }

        .index-box-list li .index-box-icon.icon-team:hover{
            background-color: #931900;
            border-color: #931900;
        }

        .index-box-list li .index-box-icon.icon-jd:hover i{
            background-image: url(../assets/img/icons/jd_w.png);
        }

        .index-box-list li .index-box-icon.icon-jd:hover{
            background-color: #c82423;
            border-color: #c82423;
        }
     }

    @media (max-width: 768px){
        /*.col-xs-6{
            padding-left: 0rem;
            padding-right: 0rem;
        }*/

        .product-list .product-info{
            padding: 0.8rem 0.4rem 1.2rem;
        }
        /*.product-list .product-info.pull-right{
            padding: 1.6rem 0.8rem 0.6rem 0.4rem;
        }*/

        .product-list .product-info.pull-left{
            padding: 0.8rem 0rem 0.6rem 0.4rem;
        }

        .product-list{
            margin-top: 0px;
            overflow: hidden;
        }

        .product-list:nth-child(2n+1){
            background: #ffffff;
        }

        #product-c5{
            background: url(../assets/img/index-c5-mbl-bg.jpg) no-repeat center;
            background-size: cover;
        }

        .product-list h3{
            font-size: 0.8rem;
            font-weight: 400;
            margin-bottom: 0.3rem;
            text-align: center;
        }

        .product-list .product-desc{
            border-top: none;
            padding-top: 0.1rem;
            text-align: center;
        }
        .product-list .product-desc p{
            font-size: 0.5rem;
            line-height: 0.7rem;
        }

        .product-list .btn-group{
            position: relative;
            text-align: center;
            left: 50%;
            transform: translate(-50%, 0);
            margin-top: 0.8rem; 
        }

        .product-list .btn{
            padding: 0.2rem 0.4rem;
            height: 1.2rem;
            font-size: 0.3rem;
        }

        .product-list .icon-eye{
            width: 0.8rem;  
            height: 0.65rem; 
            background-size: contain;
        }

        .product-list .btn.btn-text{
            /*padding: 0.15rem 0.4rem;*/
        }

        .product-list .btn-group{
            bottom: 0.3rem;
        }

        .product-more{
            width: 7rem;
            height: 1.8rem;
            font-size: 0.5rem;
            margin: 2rem auto;
        }

        .index-box-list{
            width: auto;
            left: 0;
            transform: none;
            padding: 0 0.6rem;
        }

        /*.index-box-list .col-xs-3{
            padding-right: 0.5rem;
            padding-left: 0.5rem;
        }*/

        .index-box-list li{
            margin-bottom: 20px;
            
        }

        .concern-box li{
            margin-bottom: 0px;
        }

        .index-box-name{
            margin-top: 6px;
            font-size: 0.5rem;
        }

        /*.index-box-list li .index-box-icon{
            padding: 0.6rem;
            width: 2.6rem;
            height: 2.6rem;
            
        }
        .index-box-list li .index-box-icon i{
            width: 1.2rem;
            height: 1.2rem;
        }*/

        .index-box{
            padding: 2rem 0;
        }

        /*.product-list .row{
            margin-right: 0px;
            margin-left: 0px;
        }*/

        .index-box h2{
            font-size: 1.2rem;
        }

        .index-box-desc{
            font-size: 0.5rem;
        }

        .index-box-list{
            margin-top: 1.2rem;
        }

        .index-box-list.support{
            width: 100%;
            padding: 0px;
            margin-left: 0px;
        }
        .index-box-list.concern-us{
            overflow: hidden;
            padding: 0px;
            width: 100%;
        }
        .index-box-list.concern-us li{
            width: 50%;
            margin-right: 0px;
            border-top: 1px #dadfe2 solid;
            padding: 2rem 0;
            
        }

        .index-box-list.concern-us li:nth-child(2n){
            border-left: 1px #dadfe2 solid;
        }

        .index-box-list.concern-us li .concern-icon{
            border: none;
            padding: 0px;
            height: auto;
        }

        .index-box-list.concern-us li .concern-icon i{
            width: 2.6rem;
            height: 1.6rem;
        }

        .index-box-list.concern-us li .index-box-name{
            display: none;
        }

        .concern-box{
            padding-bottom: 0;
        }

    }
</style>


// WEBPACK FOOTER //
// src/pages/index.vue